module.exports = __webpack_public_path__ + "img/192.fd0a2037.jpg";